import { render, staticRenderFns } from "./LpuStaffAdmin.vue?vue&type=template&id=51566719&scoped=true&"
import script from "./LpuStaffAdmin.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuStaffAdmin.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuStaffAdmin.vue?vue&type=style&index=0&id=51566719&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51566719",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51566719')) {
      api.createRecord('51566719', component.options)
    } else {
      api.reload('51566719', component.options)
    }
    module.hot.accept("./LpuStaffAdmin.vue?vue&type=template&id=51566719&scoped=true&", function () {
      api.rerender('51566719', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuStaffAdmin/LpuStaffAdmin.vue"
export default component.exports